import { render, staticRenderFns } from "./PageProdazha.vue?vue&type=template&id=4cf6fb5a&scoped=true&"
import script from "./PageProdazha.vue?vue&type=script&lang=js&"
export * from "./PageProdazha.vue?vue&type=script&lang=js&"
import style0 from "./PageProdazha.vue?vue&type=style&index=0&id=4cf6fb5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf6fb5a",
  null
  
)

export default component.exports